import { produce } from 'immer';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Dialog, Link, Table } from 'tdesign-react';
import { setVersionList } from '@/slices/execFlowSlice';
import useTable from '@/hooks/useTable';
import Descriptions from '@/components/Descriptions';

function ComponentInfo({ currentAdvancedStep, versionList, setVersionList }) {
  const [visible, setVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const { productLibList } = currentAdvancedStep;
  const currentLib = versionList.find(
    (item) => item.componentsId === currentAdvancedStep.stencilId,
  );

  const columns = [
    {
      colKey: 'row-select',
      type: 'single',
      fixed: 'left',
      width: 46,
    },
    {
      title: '版本号',
      colKey: 'version',
      width: 100,
    },
    {
      title: '描述',
      colKey: 'productDesc',
      width: 300,
      ellipsis: true,
    },
    {
      title: '路径',
      colKey: 'path',
      ellipsis: true,
    },
  ];

  useEffect(() => {
    if (visible && currentLib) {
      setSelectedRowData([currentLib]);
    }
  }, [currentLib, visible]);

  const { config, setData } = useTable({
    columns,
  });

  useEffect(() => {
    setData(productLibList);
  }, [productLibList, setData]);

  const onSelectChange = (value, { selectedRowData }) => {
    setSelectedRowData(selectedRowData);
  };

  const onConfirm = () => {
    const selected = selectedRowData[0];
    setVersionList(
      produce(versionList, (draft) => {
        const currentIndex = draft.findIndex((item) => item.componentsId === selected.componentsId);
        draft[currentIndex] = selected;
      }),
    );
    setVisible(false);
  };

  return (
    <Root>
      <Descriptions>
        <Descriptions.Item label='版本' value={currentLib?.version} />
        <Descriptions.Item span={2} label='路径' value={currentLib?.path} />
      </Descriptions>
      <Link theme='primary' hover='color' onClick={() => setVisible(true)}>
        选择版本
      </Link>
      <Dialog
        width='80%'
        visible={visible}
        placement='center'
        header='版本列表'
        onClose={() => setVisible(false)}
        onConfirm={onConfirm}
      >
        <Table
          rowKey='id'
          {...config}
          selectedRowKeys={selectedRowData.map((item) => item.id)}
          onSelectChange={onSelectChange}
          selectOnRowClick
        />
      </Dialog>
    </Root>
  );
}

export default connect(
  (state) => ({
    versionList: state.execFlow.versionList,
  }),
  {
    setVersionList,
  },
)(ComponentInfo);

const Root = styled.div`
  margin: 6px 12px;
`;
